import { createStructuredSelector } from "reselect";
import {
    UNSPSC_LIST,
    UNSPSC_LIST_SUCCESS,
    UNSPSC_LIST_ERROR,
    UNSPSC_PAGE_SET,
    UNSPSC_HEADER,
    UNSPSC_SEARCH_SET,
    UNSPSC_SEARCH_CHANGE,
    UNSPSC_ADD_SET,
    UNSPSC_ADD_MODAL_SET,
    UNSPSC_ADD,
    UNSPSC_ADD_SUCCESS,
    UNSPSC_ADD_ERROR,
    UNSPSC_ADD_CHANGE,
    UNSPSC_EDIT_SET,
    UNSPSC_EDIT_CHANGE,
    UNSPSC_EDIT_MODAL_SET,
    UNSPSC_DETAIL,
    UNSPSC_DETAIL_SUCCESS,
    UNSPSC_DETAIL_ERROR,
    UNSPSC_UPDATE,
    UNSPSC_UPDATE_SUCCESS,
    UNSPSC_UPDATE_ERROR
} from "../actions";

export const NAME = 'unspsc';

export const UnspscList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: UNSPSC_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const UnspscListSuccess = (data) => ({
    type: UNSPSC_LIST_SUCCESS,
    payload: data
});

export const UnspscListError = (error) => ({
    type: UNSPSC_LIST_ERROR,
    payload: error
});

export const UnspscPageSet = (data) => ({
    type: UNSPSC_PAGE_SET,
    payload: data
});

export const UnspscHeader = (data) => ({
    type: UNSPSC_HEADER,
    payload: data
})

export const UnspscSearchSet = (data) => ({
    type: UNSPSC_SEARCH_SET,
    payload: data
});

export const UnspscSearchChangeSet = (data) => ({
    type: UNSPSC_SEARCH_CHANGE,
    payload: data
});


export const UnspscAddChangeSet = (data) => ({
    type: UNSPSC_ADD_CHANGE,
    payload: data
});

export const UnspscAddSet = (data) => ({
    type: UNSPSC_ADD_SET,
    payload: data
});

export const UnspscAddModalSet = (data) => ({
    type: UNSPSC_ADD_MODAL_SET,
    payload: data
});

export const UnspscAdd = (data) => ({
    type: UNSPSC_ADD,
    payload: data
});

export const UnspscAddSuccess = (message) => ({
    type: UNSPSC_ADD_SUCCESS,
    payload: message
});

export const UnspscAddError = (error) => ({
    type: UNSPSC_ADD_ERROR,
    payload: error
});

export const UnspscEditSet = (data) => ({
    type: UNSPSC_EDIT_SET,
    payload: data
});

export const UnspscEditChangeSet = (data) => ({
    type: UNSPSC_EDIT_CHANGE,
    payload: data
});

export const UnspscEditModalSet = (data) => ({
    type: UNSPSC_EDIT_MODAL_SET,
    payload: data
});

export const UnspscEditTabSet = (data) => ({
    type: UNSPSC_EDIT_TAB_SET,
    payload: data
});

export const UnspscDetail = (data) => ({
    type: UNSPSC_DETAIL,
    payload: data
});

export const UnspscDetailSuccess = (data) => ({
    type: UNSPSC_DETAIL_SUCCESS,
    payload: data
});

export const UnspscDetailError = (error) => ({
    type: UNSPSC_DETAIL_ERROR,
    payload: error
});

export const UnspscUpdate = (data) => ({
    type: UNSPSC_UPDATE,
    payload: data
});

export const UnspscUpdateSuccess = (message) => ({
    type: UNSPSC_UPDATE_SUCCESS,
    payload: message
});

export const UnspscUpdateError = (error) => ({
    type: UNSPSC_UPDATE_ERROR,
    payload: error
});



const unspsc = (state) => state[NAME];

export const UnspscSelector = createStructuredSelector({
    unspsc
})
